namespace advisorop.components.dashboardwidgets {
    
    export class HouseholdListController{

        showChangeColumn ;
        filterRow ;
        searchPanel ;
        investorHouseholds;
        investorId;
        includeClosed;
        refreshGrid;
        households; 
        dgHouseholdsSettings: DevExpress.ui.dxDataGridOptions;
        onHouseholdChanged: (any) => any;
        onHouseholdsLoading: (any) => any;
        adminMode: boolean = false;
        recordStatusDeleted = domains.RecordStatus.DELETED;

      constructor(private advisorService: services.AdvisorService,
        private generalService: services.GeneralService,
        private $rootScope: ng.IRootScopeService) {

            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                this.adminMode = this.advisorService.isAdminModeEnabled();
            });

            this.dgHouseholdsSettings = {
                export: {
                    enabled: true,
                    fileName: "HouseHolds"
                },
                bindingOptions: {
                    dataSource: "vm.households",
                    "filterRow.visible": "vm.filterRow=='1'",
                    "columns[4].visible": "vm.showChangeColumn == '1' && !vm.adminMode"                    
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },                
                //height: "350px",
                paging: { pageSize: 20 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                noDataText: "Household Not Found",
                //stateStoring: {
                //    enabled: true,
                //    type: "localStorage",
                //    storageKey: "dgHouseholdsSettings"
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: this.searchPanel == "1",
                    width: 240,
                    placeholder: "Search..."
                    

                },
                wordWrapEnabled: true,                            
                columns: [
                    { dataField: "name", caption: "Name", width: 120, cellTemplate: "lnkName", visible: true },
                    { dataField: "advisoryFirm.advisoryFirmName", caption: "Advisory Firm", visible: true, width: 100 },
                    { dataField: "usdMarketValue", caption: "Market Value", format: "currency", visible: true, width: 115 },
                    { dataField: "advisorsStr", caption: "Advisors", width: 115, visible: true },
                    { dataField: "leadAnalystsStr", caption: "Lead Analyst(s)", visible: true },
                    { dataField: "recordStatusDescription", caption: "Status" },
                    { dataField: "id", caption: "Report Action", cellTemplate: "btnAction", width:125, visible: true },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: 150, visible: (this.showChangeColumn == "1" && !this.advisorService.isAdminModeEnabled()) }                    
                ],
                selection: {
                    mode: "single",
                    showCheckBoxesMode: "onClick"
                },
                onSelectionChanged: function (selectedItems) {
                    var data = selectedItems.selectedRowsData[0];
                    if (data) {
                        this.vm.onHouseholdChanged({id: data.id});
                    }
                }
            };
            
      }

      //syncHhWithPp(householdId: number) {
      //  this.advisorService.syncHouseholdWithPp(householdId).then(data => {
      //    toastr.success("Household has been successfully syncronized");
      //  }, err => this.generalService.showError(err));
      //}

        loadHouseholds(): void {
            this.onHouseholdsLoading({ loading: true });
            var promise: ng.IHttpPromise<domains.IHousehold[]>;
            if (this.investorHouseholds) {
                //console.log("Loading households for individual " + this.investorId);
                promise = this.advisorService.getHouseholdsByInvestor(this.investorId);
            }
            else {
                const includeClosed = this.includeClosed === "true"; // explicitly convert string to boolean
                promise = this.advisorService.getHouseholds(true, true, includeClosed);
            }

            promise.success((data) => {
                this.households = data;
                //console.log("Returned households");
                //console.log(this.households);

            }).error((data, status) => {
                toastr.error("Households cannot be loaded. ERROR " + status + ":" + data);
            }).finally(() => this.onHouseholdsLoading({ loading: false }));
        };

        deleteHousehold(householdId: number) {
            var msg = "If you select this option, you will no longer be able to use this household."
                + "\n\nARE YOU SURE?\n\nPRESS OK TO CONFIRM, CANCEL TO GO BACK.";
            if (window.confirm(msg)) {
                this.advisorService.removeHousehold(householdId).then((data) => {
                    let removeHouseHold: domains.IHousehold = data.data;
                    toastr.info(`Household: ${removeHouseHold.name} has been removed!`);
                    this.loadHouseholds();
                }).catch((err) => {
                    toastr.error(`Error ${err.status} ${err.data}`);
                });;
            }
        }

        $onChanges(evt): void {
            //{ currentValue, previousValue, isFirstChange() }   
            //console.log(evt);
            for (var key in evt) {
                if (key == "investorId") {
                    //console.log(evt[key]);
                    this.investorId == evt[key].currentValue;
                    this.loadHouseholds();
                }
                else if (key == "refreshGrid") {
                    this.loadHouseholds();
                }
            }            
        }

        $onInit(): void {
            this.adminMode = this.advisorService.isAdminModeEnabled();
        }
        
    }
    
    class HouseholdList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                //households: "<",
                showChangeColumn: "@",
                filterRow: "@",
                searchPanel: "@",
                investorId: "<",
                refreshGrid: "<",
                investorHouseholds: "@",
                onHouseholdChanged: "&",
                onHouseholdsLoading: "&",
                includeClosed: "@"
            };
          this.controller = ["advisorService","generalService", "$rootScope", HouseholdListController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/household-list.html';
        }
    }
    angular.module(Constants.APP).component("householdList", new HouseholdList());

}